var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
export var ContainerLayout = function (_a) {
    var children = _a.children;
    return _jsx(Stack, __assign({ paddingX: { xs: "0.5rem", md: "8rem" } }, { children: children }));
};
